// Router utility to prevent navigation conflicts
let isNavigating = false;
let navigationQueue = [];

export function safeNavigate(router, location) {
  if (isNavigating) {
    // Queue the navigation if one is already in progress
    navigationQueue.push(() => safeNavigate(router, location));
    return Promise.resolve();
  }
  
  isNavigating = true;
  
  return router.push(location).catch(err => {
    // Handle different types of navigation errors
    if (err.name === 'NavigationDuplicated') {
      // Ignore duplicate navigation errors
      return;
    } else if (err.message && err.message.includes('Redirected when going from')) {
      // Handle navigation guard redirects
      console.warn('Navigation redirected by guard:', err.message);
      return;
    } else {
      console.error('Navigation error:', err);
      throw err;
    }
  }).finally(() => {
    // Reset flag and process queue after navigation attempt
    setTimeout(() => {
      isNavigating = false;
      
      // Process next navigation in queue
      if (navigationQueue.length > 0) {
        const nextNavigation = navigationQueue.shift();
        nextNavigation();
      }
    }, 100);
  });
}

export function safeReplace(router, location) {
  if (isNavigating) {
    // Queue the navigation if one is already in progress
    navigationQueue.push(() => safeReplace(router, location));
    return Promise.resolve();
  }
  
  isNavigating = true;
  
  return router.replace(location).catch(err => {
    // Handle different types of navigation errors
    if (err.name === 'NavigationDuplicated') {
      // Ignore duplicate navigation errors
      return;
    } else if (err.message && err.message.includes('Redirected when going from')) {
      // Handle navigation guard redirects
      console.warn('Navigation redirected by guard:', err.message);
      return;
    } else {
      console.error('Navigation error:', err);
      throw err;
    }
  }).finally(() => {
    // Reset flag and process queue after navigation attempt
    setTimeout(() => {
      isNavigating = false;
      
      // Process next navigation in queue
      if (navigationQueue.length > 0) {
        const nextNavigation = navigationQueue.shift();
        nextNavigation();
      }
    }, 100);
  });
}

export function isCurrentlyNavigating() {
  return isNavigating;
}

export function clearNavigationQueue() {
  navigationQueue = [];
}
